import type { MusinsaStandardResponse } from '@musinsa/packages-http';
import { executeStandardRequest } from '@musinsa/packages-http';
import urlJoin from 'url-join';
import { z } from 'zod';
import { privateHttpClient } from '../httpClient';
import { productsApiPath } from './apiPath';

// Request Schema
export const CreateProductLinkRequestParamsSchema = z.object({
  productId: z.string().min(1, '상품 ID는 필수입니다'),
});

export type CreateProductLinkRequestParams = z.infer<typeof CreateProductLinkRequestParamsSchema>;

export const CreateProductLinkResponseSchema = z.object({
  isCurator: z.boolean(),
  link: z.string().url('올바른 URL 형식이어야 합니다'),
});

export type CreateProductLinkResponseData = z.infer<typeof CreateProductLinkResponseSchema>;

export type CreateProductLinkResponse = MusinsaStandardResponse<CreateProductLinkResponseData>;

export const createProductLink = (params: CreateProductLinkRequestParams) =>
  executeStandardRequest(() =>
    privateHttpClient.post<CreateProductLinkResponse>(
      urlJoin(productsApiPath.createProductLink, params.productId),
    ),
  );
